import { render } from "./returnDialog.vue?vue&type=template&id=c1089ba4"
import script from "./returnDialog.vue?vue&type=script&lang=js"
export * from "./returnDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__